import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { alignItems, strCode } from "../../consts";
import { t } from "../../services";
import { withSection } from "../../hoc";

import Modal from "../Modal/Modal";
import WrapperContainer from "../Containers/WrapperContainer";
import FlexContainers from "../Containers/FlexContainers";
import { Heading5 } from "../Text/Headings";
import SmallButton from "../Buttons/SmallButton";
import { Paragraph2 } from "../Text/Paragraphs";
import Checkbox from "../Checkbox/Checkbox";
import { CheckboxWrapper, DiscardModalWrapper } from "./styled";

const getLocalStorageItem = (storageItem) => {
  const dontShowModalValue = storageItem ? localStorage.getItem(storageItem) : null;
  let dontShowModal = false;

  if (dontShowModalValue) {
    try {
      dontShowModal = JSON.parse(dontShowModalValue);
    } catch (e) {
      dontShowModal = false;
      localStorage.removeItem(storageItem);
    }
  }

  return dontShowModal;
};

const saveLocalStorageItem = (storageItem) => {
  localStorage.setItem(storageItem, true);
};

const DiscardModal = ({
  title,
  text,
  loading,
  confirmBtnText,
  cancelBtnText,
  storageConfirmation,
  active,
  setActive,
  onDiscard
}) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const dontShowModal = getLocalStorageItem(storageConfirmation);

  useEffect(() => {
    if (active && dontShowModal) {
      setActive(false);
      onDiscard();
    }

    if (!active && storageConfirmation) {
      if (dontShowAgain) {
        saveLocalStorageItem(storageConfirmation);
      }

      setDontShowAgain(false);
    }
  }, [active, storageConfirmation]);

  return (
    <DiscardModalWrapper>
      <Modal id="discard-modal" active={active && !dontShowModal} closable={false} preventOverflow>
        <WrapperContainer
          Container={FlexContainers.FlexColumnStart}
          alignItems={alignItems.start}
          width={380}
          gap={16}>
          <Heading5>{t(title)}</Heading5>

          <Paragraph2 dangerouslySetInnerHTML={{ __html: t(text) }} />

          {storageConfirmation && (
            <CheckboxWrapper Container={FlexContainers.FlexRowStart} gap={16} width={"100%"}>
              <Checkbox
                id={"dont-show-again-checkbox"}
                checked={dontShowAgain}
                onCheck={() => setDontShowAgain((prev) => !prev)}
              />
              <label htmlFor={"dont-show-again-checkbox"}>{t(strCode.DONT_SHOW_AGAIN_INFO)}</label>
            </CheckboxWrapper>
          )}

          <WrapperContainer Container={FlexContainers.FlexRowEnd} gap={16} mt={8} width={"100%"}>
            <SmallButton disabled={loading} onClick={() => setActive(false)} secondary={true}>
              {cancelBtnText ? t(cancelBtnText) : t(strCode.CANCEL_BTN)}
            </SmallButton>

            <SmallButton disabled={loading} loading={loading} onClick={onDiscard} backgroundRed>
              {confirmBtnText ? t(confirmBtnText) : t(strCode.DISCARD_BTN)}
            </SmallButton>
          </WrapperContainer>
        </WrapperContainer>
      </Modal>
    </DiscardModalWrapper>
  );
};

DiscardModal.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  confirmBtnText: PropTypes.string,
  cancelBtnText: PropTypes.string,
  storageConfirmation: PropTypes.string,
  active: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default withSection(DiscardModal);
